import CommonForm from "../../components/common/form";
import { loginFormControls } from "../../config";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../../store/features/auth/authThunks";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";

const initialState = {
  email: "",
  password: "",
};

function AuthLogin() {
  const [formData, setFormData] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  

  function onSubmit(event) {
      event.preventDefault();
      
      dispatch(loginUser(formData))
        .unwrap()
        .then((payload) => {
          console.log(payload,'payload');
          
          if (payload?.status === true) {
            toast.success(payload?.message || "Registration successful!");
            navigate("/");
          } else {
            toast.error(payload?.message || "login failed");
          }
        })
        .catch((err) => {
          // Handle different error formats
          const errorMessage = err?.message || 
                             err?.payload?.message || 
                             (Array.isArray(err) ? err.join(', ') : 
                             (typeof err === 'string' ? err : 'login failed'));
          
          toast.error(errorMessage);
        });
    }

  return (
    <div className="mx-auto w-full max-w-md space-y-6">
      <div className="text-center">
        <h1 className="text-3xl font-bold tracking-tight text-foreground">
          Sign in to your account
        </h1>
        <p className="mt-2">
          Don't have an account?{" "}
          <Link
            className="font-medium text-primary hover:underline"
            to="/auth/register"
          >
            Register
          </Link>
        </p>
      </div>
      <CommonForm
        formControls={loginFormControls}
        buttonText={isLoading ? "Signing In..." : "Sign In"}
        formData={formData}
        setFormData={setFormData}
        onSubmit={onSubmit}
        disabled={isLoading}
      />
    </div>
  );
}

export default AuthLogin;